try{
if($(window).width() >= 800){
 $(function() {
  $('header-menu details').on('mouseover', function() {
    $(this).attr('open', true);
  }).on('mouseout', function() {
    $(this).attr('open', false);
  })
});
}
 $(document).ready(function(){
  $(".mobile-nav__toggle-link,.mobile-nav__toggle").click(function(e){
    if(!$(this).parent().parent().hasClass('openmenu')){
        $(this).parent().next().slideToggle();
    }else{
     $(this).parent().next().attr("style","display: none");
    }
    $(this).parent().parent().toggleClass('openmenu');
    e.preventDefault();
  });

  
  setTimeout(function() {  
    $('#wsg-quick-order-form .wsg-button-container').attr('href', '/pages/ws-cart ');
   }, 3000);
   
 
  let activeCurrency = Shopify.currency.activeCurrency;
  let currentDomain = window.location.hostname; 
  //hide specific products for CA domain
  if (activeCurrency === 'CAD' || window.location.href.indexOf("en-ca") > -1) {
    var hide_from_ca = document.getElementsByClassName('hide-from-ca');
    for (var i = 0; i < hide_from_ca.length; i++) {
      hide_from_ca[i].style.display = 'none';
    }
  }

   
});


$(document).ready(function() {
  try{
		$('#customFeaturedReviews0 .carousel-inner').slick({
				infinite: true,
                arrows: false,
                swipe: false,
                draggable: false,
				slidesToShow: 2,
				slidesToScroll: 2,
                dots: true,
                responsive: [
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
                  ]
            });
  $('#customFeaturedReviews2 .carousel-inner').slick({
				infinite: true,
                arrows: false,
                swipe: false,
                draggable: false,
				slidesToShow: 1,
				slidesToScroll: 1,
                dots: true,
                responsive: [
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
                  ]
            });
  }catch(e){
  
}
		});
}catch(e){
  
}